import { gql } from '@apollo/client';

export const LINK_YOUTUBE = gql`
  mutation linkYoutube($code: String!) {
    linkYoutube(code: $code) {
      message
      success
    }
  }
`;

export const VALIDATE_YOUTUBE = gql`
  query validateYoutube($videoId: String!) {
    validateYoutube(videoId: $videoId) {
      success
      title
      description
      tags
      thumbnail
    }
  }
`;
